module.exports = __webpack_public_path__ + "img/logo.35fda41b.png";